import React, {Component, Fragment } from 'react';
import Helmet from 'react-helmet';

const initialState = {
  id: '',
  password: '',
  showPwd: false
}

class Login extends Component {
  state = initialState;

  // 初期処理
  componentDidMount() {

  }

  // [ログイン]ボタン押下時処理
  login = () => {
    
    // 2024/12 JOHN認証処理削除
    // 低レベルセッション作成フラグ」変数を定義する
    // let lowLevelSessionFlg;

    // // 「低レベルセッション作成フラグ」に値を設定する
    // if (document.getElementById('LA_form-checkbox-02')) {
    //   // オートログインチェックボックスの画面入力値を設定する
    //   lowLevelSessionFlg = document.getElementById('LA_form-checkbox-02').checked;
    // }
    // else {
    //   // 親コンポーネントから受け取った「オートログイン状態フラグ」の値を設定する
    //   lowLevelSessionFlg = this.props.autoLoginStateFlg;
    // }
    
    // 親コンポーネントの共通ログインAPI呼出す処理を呼び出す
    // 引数
    const { id, password } = this.state;
    const info={ ORG_ID: 'userid', ID:id, PWD:password, LowLevelSessionFlg:false };
    // メソッドを呼出す
    this.props.loginMethod(info);
  }

  // 画面入力項目クリア処理
  componentDidUpdate(prevProps) {

    // 現在のエラーマップは前のエラーマップを比較し、更新された場合、画面入力項目をクリアする
    if (this.props.errMap !== prevProps.errMap) {
      // パスワードをクリアする
      this.setState({ password: '' });
    }
  }

  // パスワードマスク表示切替処理
  swhichPwdShow = e => {
    this.setState({ showPwd: e.currentTarget.checked });
  }

  handleChange = e => {
    this.setState({ [e.currentTarget.name]: e.currentTarget.value.trim() });
  }

  // Enterキー押下時処理
  handleKeyPress = e => {
    if(e.key === "Enter"){
      e.preventDefault();
      this.login();
    }
  }

  // 画面表示処理
  render() {
    
    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // RP別デザインを取得する
    let design = sessionStorage.getItem('design');
    let designI01; // 通常ログイン
    let designI02; // 企業ログイン

    // 画面、項目ID、デザイン値に該当するデザインファイルを読み込む
    if(design.startsWith('JOC')){
        designI02 = require('./design/design_Login_I02_000.js');
    }else{
        designI01 = require('./design/design_Login_I01_000.js');
    }

    // ブラウザタイトル、画面タイトル
    let browserTitle;
    let pageTitle;
    
    if(design === 'JON002N'){
      browserTitle = messageList.login.browserTitle002;
      pageTitle = messageList.login.pageTitle002;
    }else if(design === 'JON003N'){
      browserTitle = messageList.login.browserTitle003;
      pageTitle = messageList.login.pageTitle003;
    }else if(design === 'JON004N'){
      browserTitle = messageList.login.browserTitle004;
      pageTitle = messageList.login.pageTitle004;
    }else if(design === 'JOC001N'){
      browserTitle = messageList.cpLogin.browserTitle;
      pageTitle = messageList.cpLogin.pageTitle;
    }else{
      browserTitle = messageList.login.browserTitle001;
      pageTitle = messageList.login.pageTitle001;
    }
   
    return(       
      <section>
        <Helmet
          title={browserTitle} >
        </Helmet>
       
        { // Loadingモーダル表示
          this.props.loading &&
          <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/img/load.gif`} alt="loading"/></div>
        }
       
        {/* 画面タイトル表示部 */}
        <div className="hdg-l1">
          <h1 className="hdg-l1_txt">{pageTitle}</h1>
        </div>

        <div id="JS_error">
        { // エラーメッセージ表示
          (this.props.errMap && this.props.errMap.ERROR) &&              
          <div className="panel-attention">
            <h2 className="panel-attention_hdg">
              <span className="panel-attention_icon">
                <img src={`${process.env.PUBLIC_URL}/img/icon_error.svg`} alt={messageList.login.errorAlt}/>
              </span>{messageList.login.errorTitle}
            </h2>
            <p>{this.props.errMap.ERROR}</p>
          </div>/* /panel-attention */
        }
        </div>

        <div className="panel-form">
          <div className="panel-form-inner">
            <div className="panel-form-inner_item">
              {/* ========== 通常ログイン ========== */}
              {(designI01 && designI01.getDesign(
                {
                  messageListLogin:messageList.login,
                  errMap:this.props.errMap, 
                  state:this.state,
                  design,
                  handleChangeMethod:this.handleChange,
                  swhichPwdShowMethod:this.swhichPwdShow,
                  handleKeyPressMethod:this.handleKeyPress,
                  loginMethod:this.login
                }
              ))}
              {/* ========== 企業ログイン ========== */}
              {(designI02 && designI02.getDesign(
                {
                  messageListLogin:messageList.cpLogin,
                  errMap:this.props.errMap, 
                  state:this.state,
                  handleChangeMethod:this.handleChange,
                  swhichPwdShowMethod:this.swhichPwdShow,
                  handleKeyPressMethod:this.handleKeyPress,
                  loginMethod:this.login
                }
              ))}
            </div> {/* /panel-form-inner_item */}
          </div> {/* /panel-form-inner */}
        </div>
        
        {/* ご案内 */}
        <div className="hdg-guide">
          <h2 className="hdg-guide_txt">{messageList.login.noticeTitle}</h2>
        </div>

        {(designI01) ?
        // 通常ログイン
        <ul className="list">
          <li>{messageList.login.notice001}<br></br>
              {messageList.login.notice002}</li>
          <li>{messageList.login.notice003}
              <div>
                <a href="https://www.jal.co.jp/jalonline/contact/" className="link-txt _other" target="otherwindow">
                  <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageList.login.guideNewWindow} className="icon-blank"/>
                    {messageList.login.linkOnlinedesk}
                </a>
              </div>
          </li>
          <li>{messageList.login.notice004}
            <a href="https://www.jal.co.jp/jalonline/policy/browser.html" className="link-txt _other" target="_blank">
              <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageList.login.guideNewWindow} className="icon-blank"/>
                {messageList.login.linkPCEnvironment}
              </a>
              {messageList.login.notice005}
          </li>
          <li>{messageList.login.notice006}
            <a href="https://www.jal.co.jp/jalonline/rule/security.html" className="link-txt _other" target="_blank">
              <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageList.login.guideNewWindow} className="icon-blank"/>
                {messageList.login.linkPersonalInfo}
              </a>
              {messageList.login.notice007}
          </li>
          <li>{messageList.login.notice008}</li>
        </ul>:

        // 企業ログイン
        <ul className="list">
          <li>{messageList.cpLogin.notice004}
            <a href="https://www.jal.co.jp/jalonline/policy/browser.html" className="link-txt _other" target="_blank">
              <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageList.cpLogin.guideNewWindow} className="icon-blank"/>
                {messageList.cpLogin.linkPCEnvironment}
              </a>
              {messageList.cpLogin.notice005}
          </li>
          <li>{messageList.cpLogin.notice006}
            <a href="https://www.jal.co.jp/jalonline/rule/security.html" className="link-txt _other" target="_blank">
              <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageList.cpLogin.guideNewWindow} className="icon-blank"/>
                {messageList.cpLogin.linkPersonalInfo}
              </a>
              {messageList.cpLogin.notice007}
          </li>
          <li>{messageList.cpLogin.notice008}</li>
        </ul>
        }
      </section>
    );
  }
}

export default Login